import { IMAGES } from '../../lzapp_web_common_code/assets'
import {
    PRACTICE_TEST,
    APP_DOMAIN_LIST,
    QUESTION_VERSION_OF_JSON,
} from '../_shared/cloud+.data'

export { PRACTICE_TEST, APP_DOMAIN_LIST, QUESTION_VERSION_OF_JSON }

export const GET_FLASH_CARD_MENU = () => {
    return [
        {
            title: 'Bookmark',
            icon_bg: '#FFEFED',
            image: IMAGES?.ic_flash_bookmark,
            menu: null,
            key: 'bookmark',
            requires_subscription: false
        },
        {
            title: 'Quick Set (10)',
            icon_bg: '#E6FBFF',
            image: IMAGES?.ic_flash_quick_set,
            menu: null,
            key: 'quick',
            requires_subscription: false
        },
        {
            title: 'Exam Essentials',
            icon_bg: '#FFF5E6',
            image: IMAGES?.ic_flash_exam,
            menu: null,
            key: 'exam',
            topic_ids: [200],
            requires_subscription: true
        },
        {
            title: 'By Topics ',
            icon_bg: '#F3FFD9',
            key: 'by_topic',
            image: IMAGES?.ic_flash_topic,
            menu: APP_DOMAIN_LIST
        },
    ]
}

export const GET_STUDY_QUESTION_MENU = () => {
    return [
      {
        title: "Bookmark",
        icon_bg: "#FFEFED",
        image: IMAGES?.ic_flash_bookmark,
        key: "bookmark",
        menu: APP_DOMAIN_LIST
      },
      {
        title: "Quick Set (10)",
        icon_bg: "#E6FBFF",
        image: IMAGES?.ic_flash_quick_set,
        menu: null,
        key: "quick",
      },
    {
        title: 'By Topics',
        icon_bg: '#F3FFD9',
        key: 'by_topic',
        image: IMAGES?.ic_flash_topic,
        menu: APP_DOMAIN_LIST
    },
    ];
  };

export const GET_ARTICLE_MENU = () => {
    return [
      {
        title: "Bookmark",
        icon_bg: "#FFEFED",
        image: IMAGES?.ic_flash_bookmark,
        key: "bookmark",
        menu: APP_DOMAIN_LIST
      },
      {
        title: "Quick Set (10)",
        icon_bg: "#E6FBFF",
        image: IMAGES?.ic_flash_quick_set,
        menu: null,
        key: "quick",
      },
    {
        title: 'By Topics',
        icon_bg: '#F3FFD9',
        key: 'by_topic',
        image: IMAGES?.ic_flash_topic,
        menu: APP_DOMAIN_LIST
    },
    ];
  };
